export default __webpack_public_path__ + "static/media/oscer-pres-jaw-pain.082f32a6.svg";